export default __webpack_public_path__ + "static/media/opensea.9b5d43fa.svg";